var path = 'src/app/forms/submit-button.html';
var html = "<button ng-disabled=formCtrl.$invalid type=submit class=\"btn btn-success\"> <span ng-transclude></span> <i class=\"fa fa-spinner fa-spin\" ng-show=submitting></i> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/submit-button.html
 ** module id = 339
 ** module chunks = 0
 **/